import Api from '../../Components/Api';
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { ADDRESS_LIST, SAVE_USER_PROFILE, REMOVE_USER_PROFILE, FAV_MENU_ITEM, REMOVE_FAV_MENU_ITEM, ADD_GUEST, GET_PROFILE, LOG_IN, LOG_OUT, REMOVE_ORDER_LIST, SOCIAL_LOG_IN, SOCIAL_LOG_OUT, REMOVE_GUEST, SAVE_USER_CARD_DETAILS, MOB_SAVE_USER_CARD_DETAILS, ORDER_TYPES } from './customerTypes';
import _, { round } from "lodash";
import { ordersList } from './menu';
import { REMOVE_LAST_FIVE_ORDERS, REMOVE_ORDER_DATA } from './menuTypes';
import { DELIVERY_ADDRESS, EXTRA_ADDRESS, GEOCODED_ADDRESS, SET_POSITION, SET_SEARCH_STRING } from './paymentTypes';
import { SELECT_STORE } from './storeTypes';
import mergn from 'mergn-webapp-sdk'
import { IDecodedToken, PHONE_CODE, getLocale } from '../../lib';

var CryptoJS = require("crypto-js");

export const customerSignIn = (data: any, history?: any, register?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post("/customer/auth", { body: encryptedData })
      .then(async (response) => {
        if (response.data.success) {
          let token = response.data.accessToken;
          localStorage.setItem("userToken", token);
          let coupon = sessionStorage.getItem("coupon");
          if (coupon) {
            sessionStorage.removeItem("coupon");
            sessionStorage.removeItem("combovoucher");
          }
          if (!register) toast.success("Login Successfull")
          dispatch({
            type: SAVE_USER_PROFILE,
            payload: response.data.customer,
          })
          dispatch({ type: LOG_IN })
          dispatch(favoritesList())
          dispatch(ordersList());
          sessionStorage.removeItem("guestphone");
          sessionStorage.removeItem("guestName");
          dispatch({ type: REMOVE_GUEST })
          history.push(`/${getLocale()}/menu`);
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
        } else {
          alert("Connection Lost");
        }
      });
  };
};
export const signup = (data: any, history?: any, setState?: any, payemntScreen?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    return Api.post(`/customer/signup`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          let signIndata = {
            phone_number: data.phone_number,
            password: data.login_password
          }
          toast.success("Signup Successfull")
          dispatch(customerSignIn(signIndata, history, true))
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 });
        setState(false)
      });
  };
};
export const sendOtpForFP = (data: any, setShowDetaild?: any) => {
  let body = {
    phone_number: data.phone_number,
  }
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(body), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/sendOtpforFP`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success("OTP sent successfully")
          setShowDetaild(false)
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 10000 })
      });
  };
}
export const sendOtp = (data: any, setShow?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/sendOtp`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success(response.data.successResponse)
          if (setShow) {
            setShow(true)
          }
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 10000 })
      });
  };
}

export const verifyOtp = (data: any, history?: any, setState?: any) => {
  let body = {
    phone_number: data.phone_number,
    otp: data.otp,
  }
  let signupData :any= {
    first_name: data?.first_name,
    last_name: data?.last_name,
    login_name: data?.first_name + " " + data?.last_name,
    email_address: data?.email_address,
    login_password: data?.login_password,
    phone_number: data?.phone_number,
    is_active: data?.is_active
  };
  if (typeof data?.send_email !== 'undefined') signupData.send_email = data.send_email ? 1 : 0;
  if (typeof data?.send_pn !== 'undefined') signupData.send_pn = data.send_pn ? 1 : 0;
  if (typeof data?.send_sms !== 'undefined') signupData.send_sms = data.send_sms ? 1 : 0;
  if (typeof data?.check_policy !== 'undefined') signupData.check_policy = data.check_policy ? 1 : 0;
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(body), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/validateOtp`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          dispatch(signup(signupData, history, setState))
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message)
      });

  }
}



export const removeProfileData = () => {
  return {
    type: REMOVE_USER_PROFILE,
  };
};

export const saveCustomerInfo = () => {
  return function (dispatch: any) {
    try {
      const token = localStorage.getItem("userToken");
      if (!token) return null;

      const userData: IDecodedToken = jwt_decode(token);
      if (!userData?.customer) return null;

      dispatch({
        type: SAVE_USER_PROFILE,
        payload: userData.customer,
      });
      dispatch({ type: LOG_IN });
      return userData.customer;
    } catch (error) {
      console.error("Error initializing user from token:", error);
      return null;
    }
  };
};
export const removeFavList = () => {
  return {
    type: REMOVE_FAV_MENU_ITEM,
  };
};

export const updateProfileData = (id: any, formData: any, history?: any, setState?: any, setShow?: any,otpData?:any) => {
  return function (dispatch: any) {
    let token: any = localStorage.getItem('userToken');
    if(otpData){
      formData.append('otpData', otpData.otp);
    }

    Api.put(`/customer/edit_profile/${id}`, formData, {
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': "multipart/form-data" }
    })
      .then((response: any) => {
        if (response.data.success) {
          if (setShow) setShow(false);
          setState(true)
          localStorage.setItem("userToken", response.data.token)
          mergn.recordEvent("Save Information")
          let decoded: any = jwt_decode(response.data.token)
          toast.success(response.data.successResponse);
          dispatch({
            type: SAVE_USER_PROFILE,
            payload: decoded?.customer,
          })
          if (sessionStorage.getItem("socialPhone")) sessionStorage.removeItem("socialPhone")
         
        }
      }).catch((err: any) => {
        if (setShow) setShow(false)
        if (err.response) {
          let error;
          if (typeof err.response.data.message === 'string') {
            if (err.response.data.code === 'ER_DUP_ENTRY') {
              error = 'Phone number already exists';
            } else {
              error = err.response.data.message;
            }
          } else if (typeof (err.response.data.message) === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
        } else {
          toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
        }
      });
  }
}

export const addAddressUser = (data: any) => {
  return async function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      Api.post(`/customer/add_address`, { body: encryptedData }, {
        headers: { Authorization: 'Bearer ' + token },
      })
        .then((response: any) => {
          if (response.data.success) {
            toast.success(response.data.successResponse, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
            dispatch(addressesList())
          }
        }).catch((err: any) => {
          if (err.response) {
            let error;
            if (typeof (err.response.data) === "string") {
              error = err.response.data;
            } else if (typeof (err.response.data) === "object") {
              error = err.response.data;
            }
          }
        });
    }
  }
}

export const getConsentConfig = (langCode?: string) => {
  return async function () {
    const token: string | null = localStorage.getItem('userToken');
    const headers: any = {};
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }
    const locale = langCode;
    const res = await Api.get(`/customer/consent-config${locale ? `?lang_code=${locale}` : ''}`, {
      headers,
    });
    return res?.data?.successResponse || {};
  };
};
export const deleteAddress = (addressData: any, address_id: number) => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem('userToken');
    Api.delete(`/customer/del_address/${address_id}`, {
      headers: { Authorization: 'Bearer ' + token },
    })
      .then((response) => {
        if (response.data.success) {
          var filtered = addressData.filter((element: any, index: any) => {
            return element.address_id !== address_id;
          })
          dispatch({
            type: ADDRESS_LIST,
            payload: filtered
          });
          toast.success("Address deleted succesfully", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
        }
      })
      .catch((err) => {
        
      });
  };
};
export const editAddress = (address_id: any, data: any) => {
  return async (dispatch: any) => {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    let token: any = await localStorage.getItem('userToken');
    if (token) {
      Api.put(`/customer/edit_address/${address_id}`, { body: encryptedData }, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((response) => {
          if (response.data.success) {
            dispatch(addressesList())
            toast.success(response.data.successResponse, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 });
          }
        })
        .catch((err) => {
          if (err.response) {
            let error;
            if (typeof err.response.data.message === 'string') {
              error = err.response.data.message;
            } else if (typeof err.response.data.message === 'object') {
              error = err.response.data.message[0].replace(/_/g, ' ');
            }

          } else {

          }
        });
    }
  };
};
export const setDefaultAddress = (address_id: any) => {

  return async (dispatch: any) => {
    let token: any = localStorage.getItem("userToken")
    if (token) {
      let customerData: any = jwt_decode(token);
      let obj = {
        customer_id: customerData.customer.customer_id, address_id: address_id
      }
      var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
      Api.put(`/customer/set_default_address`, { body: encryptedData }, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }).then((response: any) => {
        dispatch(addressesList())
        if (response.data.success) {
          toast.success("Address set to default", {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
        }
      }).catch((err: any) => {
        toast.error("Some error occurred", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })
    }
  }


}
export const addressesList = () => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      var decoded: any = jwt_decode(token);
      Api.get(`/address/${decoded.customer.customer_id}`, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((response) => {
          if (response.data.success) {
            dispatch({
              type: ADDRESS_LIST,
              payload: response.data.successResponse,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            let error;
            if (typeof err.response.data.message === "string") {
              error = err.response.data.message;
            } else if (typeof err.response.data.message === "object") {
              error = err.response.data.message[0].replace(/_/g, " ");
            }
            dispatch({
              type: ADDRESS_LIST,
              payload: [],
            });
          } 
        });
    }
  };
};

export const changePasswordOtp = (data: any, history?: any) => {
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
  return function (dispatch: any) {
    Api.post('/customer/changePasswordOtp', { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          toast.success('Your password has been reset.', { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          let signIndata = {
            phone_number: data?.phone,
            password: data.password
          }
          dispatch(customerSignIn(signIndata, history, true))
        }
        
      }).catch(err => {
        if (err.response) {

          let error;
          if (typeof (err.response.data.message) === "string") {
            toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          } else if (typeof (err.response.data.message) === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
        }
      });
  }
}

export const saveCareer = (data: any, history?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    return Api.post(`/customer/career`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success("Career Successfull")
          history.push("/")
        }
      })
      .catch((err: any) => {
        if (err.response) {
          toast.error(err.response.data.message);
        }
        else {
        }
      });
  };
};
export const loginCustomerWithSocial = (data: any, history?: any, route?: any) => {
  return async (dispatch: any) => {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post("/customer/signinwithsocial", { body: encryptedData })
      .then(async (response) => {
        if (response.data.success) {

          let token = response.data.accessToken;
          let decoded: any = jwt_decode(token)
          localStorage.setItem("userToken", token);
          dispatch({
            type: SAVE_USER_PROFILE,
            payload: decoded?.customer,
          })
          dispatch({ type: LOG_IN })
          dispatch({ type: SOCIAL_LOG_IN })
          sessionStorage.removeItem("guestphone");
          sessionStorage.removeItem("guestName");
          dispatch({ type: REMOVE_GUEST })
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'social_user'
          });

          let reg = /^(?:0|3)(?:3)[0-9]{9}$/;
          if (reg.test(decoded.customer.phone_number) == false || _.isEmpty(decoded.customer.login_name) || decoded.customer.login_name == ' ') {
            toast.error("Update your profile information", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
            sessionStorage.setItem("socialPhone", "true");
            history.push(`/${getLocale()}/my-details`);
          } else {
            toast.success("Login Successfully !", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
            if (route) history.push(route)
            else history.push('/')
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");

          }
          toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 })
        } else {
          alert("Connection Lost");
        }
      });
  };
};

export const favoritesList = () => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem('userToken');
    if (token) {
      var decoded: any = jwt_decode(token);
      Api.get(`/customer/wishlist/${decoded.customer.customer_id}/online`, {
        headers: { Authorization: 'Bearer ' + token },
      })
        .then((response) => {
          if (response.data.success) {
            dispatch({
              type: FAV_MENU_ITEM,
              payload: response.data.successResponse,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            let error;
            if (typeof err.response.data.message === 'string') {
              error = err.response.data.message;
            } else if (typeof err.response.data.message === 'object') {
              error = err.response.data.message[0].replace(/_/g, ' ');
            }
            dispatch({
              type: FAV_MENU_ITEM,
              payload: [],
            });
          } else {

          }
        });
    }
  };
};
export const favouriteAdd = (data: any, setState: any) => {

  return async (dispatch: any) => {
    let token: any = await localStorage.getItem("userToken");
    if (token) {
      var decoded: any = jwt_decode(token);
      data.customer_id = decoded.customer.customer_id;
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();

    Api.post("customer/add_wishlist", { body: encryptedData }, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        if (response.data.success) {
          setState(true)
          let products: any = []
          let MapObj: any = {
            product: data.product
          }
          products.push(MapObj)
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'addFavourite',
            'ecommerce': {
              'add': {
                'products': products
              }
            }
          });
          toast.success(response.data.successResponse, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
       
        }


      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            error = err.response.data.message;
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }

        } else {

        }
      });
  };
};
export const deletefavourites = (wish_id: number, data: any) => {
  return async (dispatch: any) => {
    let token: any = await localStorage.getItem('userToken');
    Api.delete(`/customer/del_wish/${wish_id}`, {
      headers: { Authorization: 'Bearer ' + token },
    })
      .then((response) => {
        if (response.data.success) {
          let products: any = []
          let MapObj: any = {
            product: data.product
          }
          products.push(MapObj)
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'removeFavourite',
            'ecommerce': {
              'remove': {
                'products': products
              }
            }
          });
          toast.success(response.data.successResponse, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          dispatch(favoritesList())
        }
      })
      .catch((err) => {
        if (err.response) {
        } else {
        }
      });
  };
};

export const careers = (data: any, history?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`customer/submit_career`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success("Submitted Successfull")
          history.push("/menu")
        }
      })
      .catch((err: any) => {
        if (err.response) {
          toast.error(err.response.data.message);
        }
        else {
        }
      });
  }
}
export const submitComplaint = (data: any, history?: any, feedback?: any, submitDisable?: (type: boolean)=> {}) => {

  return function (dispatch: any) {
    const payload = {
      ...data,
      phone_number: `${PHONE_CODE}-${data.phone_number}`,
    };
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(payload), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`/customer/feedback_application`, { body: encryptedData })
      .then((response) => {
        if (response.data.success) {
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'feedBack'
          })
          toast.success(response.data.successResponse);
          if (!feedback)
            history.push(`/${getLocale()}/`);
        }
        else {
          toast.error(response.data.message);
          if(submitDisable) {
            submitDisable(false)
          }
        }
      }).catch(err => {
        if (err.response) {
          toast.error(err.response.data.message);
        }
      });
  }
}

export const orderTypeList = () => {
  return async (dispatch: any) => { 
    Api
      .get(`/customer/order_types`, {
        headers: {
          'locale': getLocale()
        }
      })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: ORDER_TYPES,
            payload: response.data.successResponse
          })
        }
      })
      .catch((err) => {
        dispatch({
          type: ORDER_TYPES,
          payload: []
        })
      });
  }
}
export const cardDetails = () => {
  return function (dispatch: any){
    let token: any = localStorage.getItem("userToken")
    let userData: any
    userData = token ? jwt_decode(token) : null

    Api.get(`/customer/card_details`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then((response) => {
        if (response.data.success) {
          var bytes = CryptoJS.AES.decrypt(response.data.successResponse, process.env.REACT_APP_EncryptionKey);
          var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          let decryptedDataObj = decryptedData ? JSON.parse(decryptedData) : [];
          dispatch({
            type: SAVE_USER_CARD_DETAILS,
            payload: decryptedDataObj
          })
        }
      })
      .catch(err => {
        console.log(err)
        dispatch({
          type: SAVE_USER_CARD_DETAILS,
          payload: []
        })
      });
  }
}
export const MobilecardDetails = (customer_token : any) => {
  return async (dispatch: any) => {
    Api.get(`/customer/card_details`, {
      headers: { 'Authorization': 'Bearer ' + customer_token }
    })
      .then(async (response) => {
        if (response.data.success) {
          const bytes = CryptoJS.AES.decrypt(response.data.successResponse, process.env.REACT_APP_EncryptionKey);
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          const decryptedDataObj = decryptedData ? JSON.parse(decryptedData) : [];
          dispatch({
            type: MOB_SAVE_USER_CARD_DETAILS,
            payload: decryptedDataObj
          })
        }
      })
      .catch(err => {
        console.log(err)
        dispatch({
          type: MOB_SAVE_USER_CARD_DETAILS,
          payload: []
        })
      });
  }
}
export const deleteCard = (tokenId: number) => {
  return function (dispatch: any) {
    let token: any = localStorage.getItem("userToken")

    Api.delete(`/customer/delete_card/${tokenId}`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then((response) => {
        if (response.data.success) {
          toast.success("Card deleted successfully", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          dispatch(cardDetails())
        }
      })
      .catch(err => {
        if (err.response) {
          toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
        } 
        else {
          alert(err.message)
        }
      });
  }
}
export const setDefaultCard = (cardToken: any) => {
  return async (dispatch: any) => {
    
    let token: any = localStorage.getItem("userToken")
    
    if (token) {
      let customerData: any = jwt_decode(token);
      let obj = {
        customer_id: customerData.customer.customer_id, 
        card_token: cardToken
      }

      var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();

      Api.put(`customer/set_default_card`, { body: encryptedData }, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }).then((response: any) => {
        dispatch(cardDetails())
        if (response.data.success) {
          toast.success("Card set to default", {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
        }
      }).catch((err: any) => {
        toast.error("Some error occurred", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })
    }
  }
}
export const changePassword = (newPass: any, history?: any) => {
  return function (dispatch: any) {
    let token: any = localStorage.getItem("userToken")
    let userData: any
    userData = token ? jwt_decode(token) : null
    let id: any = userData && userData.customer && userData.customer.customer_id;

    let obj = {
      customer_id: id,
      login_password: newPass
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
    Api.put(`/customer/change_password`, {
      body: encryptedData
    }, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then((response) => {
        if (response.data) {
          toast.success("Password changed successfully Login now", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          dispatch(logoutUser(history));

        }
      }).catch(err => {
        if (err.response) {
          toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })

        } else {
          alert(err.message)
        }
      });
  }
}

export const logoutUser = (history?: any) => {
  return async (dispatch: any) => {
    localStorage.removeItem("userToken");
    dispatch({ type: REMOVE_USER_PROFILE })
    dispatch({ type: REMOVE_FAV_MENU_ITEM });
    dispatch({ type: LOG_OUT })
    dispatch({ type: REMOVE_ORDER_LIST })
    dispatch({ type: REMOVE_LAST_FIVE_ORDERS })
    dispatch({ type: REMOVE_ORDER_DATA })
    dispatch({ type: SOCIAL_LOG_OUT })
    dispatch({ type: DELIVERY_ADDRESS, payload: "" })
    dispatch({ type: GEOCODED_ADDRESS, payload: "" })
    dispatch({ type: EXTRA_ADDRESS, payload: "" })
    dispatch({ type: SELECT_STORE, storeSelected: null })
    dispatch({
      type: ADDRESS_LIST,
      payload: [],
    });
    dispatch({
      type: SET_POSITION,
      position: null
    });
    dispatch({
      type: SET_SEARCH_STRING,
      searchString: null
    });
    sessionStorage.removeItem("socialPhone");
    history.push(`/${getLocale()}/login`);
  }
}

export const guestVerifyOtp = (data: any, history?: any, setState?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/validateOtp`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success(response.data.successResponse)
          let token = response.data.accessToken;
          if (token) {
            localStorage.setItem("userToken", token)
            dispatch({
              type: SAVE_USER_PROFILE,
              payload: response.data.customer,
            })
            dispatch({ type: LOG_IN })
            dispatch(favoritesList())
            dispatch(ordersList());
            history.push(`/${getLocale()}/payment-method`);
            
          } else {
            setState(false)
          }

        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message)
      });

  }
}

export const addGuest = (data: any, history: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    Api.post(`/customer/addGuest`, { body: encryptedData })
      .then(async (response) => {
        if (response.data.success) {
          sessionStorage.setItem("guestName", data?.login_name)

          if (response.data.accessToken) {
            localStorage.setItem("userToken", response.data.accessToken)
            dispatch({
              type: SAVE_USER_PROFILE,
              payload: response.data.customer
            });
            dispatch({
              type: LOG_IN
            })
            history.push('/payment-method')
          } else {
            dispatch({
              type: ADD_GUEST,
              payload: response.data.successResponse
            });
            history.push('/payment-method')
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          let error;
          if (typeof err.response.data.message === "string") {
            if (err.response.data.code === 'ER_DUP_ENTRY') {
              if (err.response.data.message.indexOf("phone_number") > -1) {
                error = 'Phone number already exists';
              } else {
                error = 'Email already exists';
              }
            } else {
              error = err.response.data.message;
            }
          } else if (typeof err.response.data.message === "object") {
            error = err.response.data.message[0].replace(/_/g, " ");
          }
          toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
        } else {
        }
      });
  };
};


export const getProfile = (id: any, confirmOrderFn?: any, setRadioBtn?: any, validateStoreSpecification?: any,history?:any,editProfile?:any) => {
  return function (dispatch: any) {
    let token: any = localStorage.getItem("userToken");
    Api.get(`/customer/profile/${id}`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then((response) => {
        if (response.data.success) {
          dispatch({
            type: GET_PROFILE,
            payload: response.data.successResponse
          })
          if (confirmOrderFn) {
            if (response.data.successResponse.is_active == 1) {
              confirmOrderFn()
            } else {
              toast.error("Your access to our website has been temporarily suspended due to unusual activity. We apologize for the inconvenience caused. For assistance, please contact our customer support team. Thank you for your understanding.", {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 10000,
              });
            }
          }
          if (validateStoreSpecification) {
            if (response.data.successResponse.is_active == 1) {
              validateStoreSpecification();
            } else {
              toast.error("Your access to our website has been temporarily suspended due to unusual activity. We apologize for the inconvenience caused. For assistance, please contact our customer support team. Thank you for your understanding.", {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 10000,
              });
            }
          }
          if(editProfile && response.data.successResponse.is_active == 0){
            toast.error("Your access to our website has been temporarily suspended due to unusual activity. We apologize for the inconvenience caused. For assistance, please contact our customer support team. Thank you for your understanding.", {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 10000,
              });
          }
        }
      }).catch(err => {
        if (err.response) {
          if (err.response.data.statusCode == 401) {
            let error = err.response.data.error;
            toast.error(error, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 10000 })
            dispatch(logoutUser(history));
          } else {
            toast.error("Error", { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
          }
        } else {
          toast.error(err.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true, autoClose: 3000 })
        }
      });
  }
}

// below new login scenario
export const verifyOtpNew = (data: any, history?: any, route?: any, setShow?: any, setShowDetaild?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/validateOtp`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          toast.success(response.data.successResponse)
          let token = response.data.accessToken;
          if (token) {
            localStorage.setItem("userToken", token)
            dispatch({
              type: SAVE_USER_PROFILE,
              payload: response.data.customer,
            })
            dispatch({ type: LOG_IN })
            mergn.recordEvent('Login Submit')
            if (route) history.push(route)
            let windowObj = (window as any)
            windowObj.dataLayer.push({ ecommerce: null });
            windowObj.dataLayer.push({
              'event': 'login'
            });
          } else {
            //setShow(false)
            setShowDetaild(false)
          }

        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message)
        // console.log(err?.response)
      });

  }
}

export const signupNew = (data: any, history?: any, route?: any, emailLogin?: any) => {
  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_EncryptionKey).toString();
    return Api.post(`customer/create_account`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          let token = response.data.accessToken;
          if (token) {
            localStorage.setItem("userToken", token);
            dispatch({
              type: SAVE_USER_PROFILE,
              payload: response.data.customer,
            })
            dispatch({ type: LOG_IN })
            dispatch(favoritesList())
            dispatch(ordersList());
            toast.success("Login Successfully!")
            let windowObj = (window as any)
            windowObj.dataLayer.push({ ecommerce: null });
            windowObj.dataLayer.push({
              'event': 'new_user'
            });
            mergn.recordEvent("Signup Submit")
            if (route) history.push(route)
            else history.push(`/${getLocale()}/menu`)
          }

        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: false, autoClose: 3000 });
        //setState(false)
      });
  };
};
export const editProfileverifyOtp = (otpData: any, data: any, customer_id: any, setDisableBtn: any, setShow: any) => {

  return function (dispatch: any) {
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(otpData), process.env.REACT_APP_EncryptionKey).toString();

    return Api.post(`/customer/validateOtp`, { body: encryptedData })
      .then((response: any) => {
        if (response.data.success) {
          dispatch(updateProfileData(customer_id, data, false, setDisableBtn, setShow,otpData))
          mergn.recordEvent("Save Information")
        }
      })
      .catch((err: any) => {
        toast.error(err.response.data.message)
      });

  }
}
